
import { Vue, Component } from 'vue-property-decorator';
import CheckoutCard from '@/features/shipment/components/checkout/index.vue';

@Component({
  components: {
    CheckoutCard,
  },
})
export default class PaymentMethods extends Vue {}
